export const NSBLogo = ({ className = "h-10", light = true }) => (
  <img
    src={light ? "/nsb-logo-dark.jpeg" : "/nsb-logo-light.jpeg"}
    alt="National Scouting Bureau"
    className={`${className} object-contain`}
  />
);
